<template>
  <div>
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="relative">
        <vs-icon icon-pack="speakol" icon="speakol-bill" class="notifications-icon cursor-pointer"/>
      </div>
      <div v-if="showNotificationCounter"
           :class="`notifications-counter ${notificationColorClass} ${isNotificationCounterGreaterThan9 ? 'notifications-counter-big' : ''}`">
        {{ notificationCounter }}
      </div>
      <vs-dropdown-menu ref="notification-dropdowns" class="notifications-parent fixed">
        <div class="notifications-dropdown">
          <h4 class="mb-8 title">{{ $t("Notifications") }}</h4>
          <!-- notifications empty state -->
          <div class="notifications-empty-state" v-if="notificationList.length === 0">
            <img src="/img/empty_page.2ea2b496.svg" alt="">
            <h5>{{ $t("You have no New Notifications right now.") }}</h5>
            <h6>{{ $t("New Notifications will be displayed here.") }}</h6>
          </div>
          <!-- notifications empty state -->

          <div class="not-empty" v-else>
            <!-- notifications list here -->
            <ul>
              <div class="notifications-list">
                <li v-for="notification in notificationList" :class="isViwed(notification) ? '' : 'notification-not-read' " v-bind:key="notification.id" v-bind:id="notification.id" v-view="viewHandler">
                  <div class="notification">
                    <div class="dismiss-notification" v-if="notification.data.dismissible">
                      <vs-icon class="dismiss-icon" icon="speakol-cancel" icon-pack="speakol"
                              v-on:click="handleCTA({href_type: 'dismiss', title: 'dismiss'}, notification.id)"/>
                    </div>
                    <div class="flex">
                        <vs-icon
                          v-if="notification.severity_name === $constants.NOTIFICATIONS_SEVERITIES.ERROR"
                          class="notifications-error notification-icon"
                          icon="speakol-warning-fill"
                          color="#DB2828"
                          icon-pack="speakol"/>
                        <vs-icon
                          v-if="notification.severity_name === $constants.NOTIFICATIONS_SEVERITIES.WARNING"
                          class="notifications-warning notification-icon"
                          icon="speakol-warning-fill"
                          color="#F2AF03"
                          icon-pack="speakol"/>
                        <vs-icon
                          v-if="notification.severity_name === $constants.NOTIFICATIONS_SEVERITIES.INFO"
                          class="notifications-info notification-icon"
                          icon="speakol-info-2"
                          icon-pack="speakol"/>
                      <div>
                        <h4>{{ notification.data.title }}</h4>
                        <h5>{{ notification.data.body }}</h5>
                        <div class="notifications-actions">
                          <button v-for="(cta, index) in notification.ctas" v-bind:key="index" v-on:click="handleCTA(cta, notification.id)">{{
                              cta.title
                            }}
                          </button>
                        </div>
                        <h6>{{ formatTime(notification.created_at) }}</h6>
                      </div>
                    </div>
                  </div>
                </li>
              </div>
            </ul>
            <!-- notifications list here -->
          </div>
        </div>

      </vs-dropdown-menu>


    </vs-dropdown>
  </div>
</template>

<script>


import moment from 'moment'
const REFERENCE = moment()
const TODAY = REFERENCE.clone().startOf('day')
const YESTERDAY = REFERENCE.clone().subtract(1, 'days').startOf('day')
const NOTIFICATIONS_POLL_INTERVAL_MINUTES = parseInt(process.env.VUE_APP_NOTIFICATIONS_POLL_INTERVAL_MINUTES || 5) * 1000 * 60

export default {
  data () {
    return {
      notificationList: [],
      notificationMeta: null,
      interval: null,
    }
  },

  mounted () {
    const isMaintenanceModeEnabled = (process.env.VUE_APP_MAINTENANCE_MODE === 'true') || false
    if (!isMaintenanceModeEnabled) {
      this.getNotificationsMeta()
      this.getNotificationsList()
      this.interval = setInterval(() => {
        this.getNotificationsMeta()
        this.getNotificationsList()
      }, NOTIFICATIONS_POLL_INTERVAL_MINUTES)
    }
  },

  computed: {
    showNotificationCounter () {
      return this.notificationMeta && this.notificationMeta.count > 0
    },

    notificationCounter () {
      return this.notificationMeta.count <= 9 ? this.notificationMeta.count : '+9'
    },

    isNotificationCounterGreaterThan9 () {
      return this.notificationCounter === '+9'
    },

    notificationColorClass () {
      return `severity_${this.notificationMeta.severity_name}`
    }
  },

  methods: {
    isViwed (notification) {
      return !!notification.viewed_at
    },
    async getNotificationsList () {
      if (!this.$store.state.authentication.isAuthenticated) {
        return clearInterval(this.interval)
      }
      const {data} = await window.axios.get('/notifications-center/list', {
        hideLoader: true
      })
      this.notificationList = (data.payload.data || []).filter(item => item.channel === 'notifications_center')
      this.lookupView = this.notificationList.reduce((hash, elem) => {
        hash[elem.id] = elem
        return hash
      }, {})
    },

    formatTime (time) {
      if (this.isToday(time)) {
        return 'Today'
      } else if (this.isYesterday(time)) {
        return 'Yesterday'
      } else {
        return `${this.$moment(time).format('Do')} of ${this.$moment(time).format('MMMM')}`
      }
    },

    isToday (time) {
      return moment(time).isSame(TODAY, 'd')
    },

    isYesterday (time) {
      return moment(time).isSame(YESTERDAY, 'd')
    },

    async getNotificationsMeta () {
      if (!this.$store.state.authentication.isAuthenticated) {
        return clearInterval(this.interval)
      }
      const {data} = await window.axios.get('/notifications-center/list-meta', {
        hideLoader: true
      })
      this.notificationMeta = data.payload
    },

    async handleCTA (cta, notification_id) {
      this.$gtag.event(`Notification-Actions-'${cta.title}`)
      await window.axios.post('/notifications-center/event', {
        notifications_ids: [notification_id],
        event_name: cta.title,
        hideLoader: true
      })
      if (cta.href_type === 'router-name' && `/${cta.href}` !== this.$route.path) {
        this.$router.push(`/${cta.href}?ref=NotificationList`)
      }

      this.$refs['notification-dropdowns'].dropdownVisible = false

      if (cta.href_type !== 'view') {
        await this.getNotificationsMeta()
        await this.getNotificationsList()
      }
    },

    viewHandler (e) {
      if (e.percentInView >= 0.8) {
        const {id} = e.target.element
        if (this.lookupView[id].viewed_at === null && this.lookupView[id].severity_name !== this.$constants.NOTIFICATIONS_SEVERITIES.ERROR) {
          this.handleCTA({href_type: 'view', title: 'view'}, id)
          this.lookupView[id].viewed_at = Date.now()
          this.getNotificationsMeta()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$notificationsEmptyStateColor: var(--graniteGray);

.severity_info {
  background: var(--speakolColor);
}

.severity_warning {
  background: var(--yellow);
}

.severity_error {
  background-color: #db2828;
}

.notifications-counter {
  border-radius: 50%;
  font-size: 12px;
  color: var(--white);
  width: 16px;
  height: 16px;
  font-family: Poppins, sans-serif;
  font-weight: 500;
  position: absolute;
  right: 6px;
  top: -6px;
}

.notifications-counter-big {
  border-radius: 12px;
  width: 24px;
  height: 16px;
  right: -3px;
}

.notifications-icon {
  margin-left: 22px;
  margin-right: 15px;
  color: var(--metalicGray);
  width: 18px;
  height: 17px;
  position: relative;
  top: 1px;
}

.notifications-parent {
  /* width */
  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #fff;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #babac0;
    border-radius: 100px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  top: 84.375px !important;
  margin-left: -2px;

  .notification-not-read {
    border-left: 3px solid var(--speakolColor);
  }

  .notifications-dropdown {
    .title {
      padding: 32px 32px 0 32px;
      font-weight: bold;
      font-size: 20px;
      line-height: 25px;
      color: var(--black);
    }

    h4 {
      font-weight: bold;
      font-style: normal;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0.233333px;
      color: var(--black);
    }

    img {
      width: 300px;
      margin-top: 50px;
      margin-bottom: 6px;
    }

    .notifications-empty-state {
      text-align: center;

      h5 {
        color: #323232;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 8px;
      }

      h6 {
        color: $notificationsEmptyStateColor;
        font-size: 14px;
        font-weight: normal;
      }
    }
  }

  .not-empty {
    /deep/.vs-icon {
      font-size: 16.5px !important;
    }

    ul {
      .dismiss-notification {
        float: right;
        display: none;

        .dismiss-icon {
          color: var(--graniteGray);
          font-size: 14px !important;
          cursor: pointer;
          margin-right: 0;
        }
      }

      li {
        padding: 0 16px;
        margin-bottom: 8px;
        margin-left: -5px;
      }

      .notification {
        padding: 7px 16px;
        border-radius: 4px;

        i {
          color: var(--speakolColor);
          font-size: 20px;
          margin-right: 10px;
        }

        .notifications-error {
          color: var(--danger-variant);
          position: relative;
          top: 4px;
        }

        .notification-info {
          color: var(--speakolColor);
          position: relative;
          top: 4px;
        }

        .notifications-warning {
          color: var(--yellow);
          position: relative;
          top: 4px;
        }

        h4 {
          color: var(--black);
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 5px;
        }

        h5 {
          color: var(--black);
          font-size: 14px;
          font-weight: 300;
          margin-bottom: 4px;
        }

        h6 {
          color: #797a7b;
          font-weight: 300;
          font-size: 14px;
          margin-top: 2px;
        }

        .notifications-actions {
          button {
            cursor: pointer;
            color: var(--speakolColor);
            margin-right: 16px;
            border: none;
            outline: none;
            box-shadow: none;
            background-color: transparent;
            font-size: 14px;
            font-weight: 300;
          }
        }
      }

      .notification:hover {
        background-color: #f9f9f9;
      }

      .notification:hover .dismiss-notification {
        display: block;
      }
    }
  }
}

::v-deep .vs-dropdown--custom {
  max-width: 510px !important;
  width: 510px;
  height: 600px !important;
  // overflow-y: scroll;
  overflow-x: hidden;
  padding: 0 !important;
}

@media (max-width: 768px) {
  ::v-deep .vs-dropdown--custom {
    max-width: 341px !important;
    width: 341px;
    height: 538px !important;
    overflow-y: scroll;
    overflow-x: hidden;
    padding: 0 !important;
  }

  .notifications-parent {
    left: 96% !important;
  }

  ::v-deep .vs-dropdown--menu--after {
    display: none !important;
  }
}

</style>
